import { render, staticRenderFns } from "./CollegeView.vue?vue&type=template&id=dcd82d06"
import script from "./CollegeView.vue?vue&type=script&lang=js"
export * from "./CollegeView.vue?vue&type=script&lang=js"
import style0 from "./CollegeView.vue?vue&type=style&index=0&id=dcd82d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports